<script>
export default {
  name: 'AzureActiveDirectorySSOCallback',
}
</script>

<template lang="pug">
.sso-callback
  .sso-info
    h2 SSO SIGNED OFF
</template>

<style scoped lang="scss">
.sso-callback {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #114325;
  display: flex;
  align-items: center;
  justify-content: center;

  .sso-info {
    background: white;
    color: #006420;
    padding: 20px 40px;
    border-radius: 1rem;
    text-align: center;
  }
}
</style>
